import { useContext } from "react";
import { ErrorFieldsContext } from "../../../../contexts/ErrorFieldsContext";
import { strings } from "../../../../strings/strings";
import { needToShowCascoAdditionalFields } from "../../../../utils/quotation";
import { addYears } from "../../../../utils/dateUtils";

export const useValidate = () => {
    const { additionalErrorFields } = useContext(ErrorFieldsContext);

    const validate = (values: any) => {
        let errors: any = {};
        const { cascoAdditionalCoverage } = values.quotation;

        const cascoAdditionalCoverageErrors: Record<string, string> = {};

        if (needToShowCascoAdditionalFields(values.quotation)) {
            validateEngineCapacity(cascoAdditionalCoverage, cascoAdditionalCoverageErrors);
        }
        validateOwnerDetails(cascoAdditionalCoverage, cascoAdditionalCoverageErrors);

        if (Object.keys(cascoAdditionalCoverageErrors).length > 0) {
            errors.quotation = { cascoAdditionalCoverage: cascoAdditionalCoverageErrors };
        }

        return errors;
    };

    const validateEngineCapacity = (coverage: any, errors: Record<string, string>) => {
        if (!coverage.covered) return;

        if (coverage.engineCapacity > 40000) {
            errors.engineCapacity = strings.engineCapacityErrorMessage;
            additionalErrorFields.push("engineCapacity");
        }
    };

    const validateOwnerDetails = (coverage: any, errors: Record<string, string>) => {
        if (coverage.ownerIsInsured) return;

        validateField("ownerName", coverage.ownerName, errors);
        validateField("ownerAddress", coverage.ownerAddress, errors);
        validateOwnerBirthDate(coverage.ownerBirthDate, errors);
    };

    const validateField = (field: string, value: any, errors: Record<string, string>) => {
        if (!value) {
            errors[field] = strings.emptyFieldErrorMessage;
            additionalErrorFields.push(field);
        }
    };

    const validateOwnerBirthDate = (birthDate: Date, errors: Record<string, string>) => {
        if (!birthDate) {
            errors.ownerBirthDate = strings.emptyFieldErrorMessage;
            additionalErrorFields.push("ownerBirthDate");
            return;
        }

        const minDate = addYears(new Date(), -100);
        const maxDate = addYears(new Date(), -18);

        if (birthDate < minDate || birthDate > maxDate) {
            errors.ownerBirthDate = strings.ownerBirthDateErrorMessage;
            additionalErrorFields.push("ownerBirthDate");
        }
    };

    return {validate}
}